// let baseUrl = "https://test123.bandaoapp.com:8009/bandao/";
// let active_url = "http://activity.bandaoapp.com/activity/vote-active-test/index.html";

let baseUrl = "http://qdly.bandaoapp.com/bandao/";//生产域名
let active_url = "http://activity.bandaoapp.com/activity/vote-active/index.html";//活动链接
export { baseUrl, active_url }
